import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { sendRequest } from "../../../apis/APIs";
import { handleApiResponse } from "../../../apis/apiUtils";
import { callCommonAction } from '../../../redux/Common/CommonReducer';
import { validateRegisterFormData } from "../Login/Validation";
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import appRoutes from '../../../configs/AppRoutes';

const Login = () => {
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.common);

    const [userDetail, setUserDetail] = useState({ email: '', password: '' });
    const [errorsInfo, setErrorsInfo] = useState({});


    const checkFormIsValid = async (fieldName = "") => {
        const res = validateRegisterFormData(userDetail, fieldName);
        if (fieldName) {
            const error = res.errors[fieldName];
            setErrorsInfo(prev => ({ ...prev, [fieldName]: error || '' }));
        } else {
            setErrorsInfo(res.errors);
        }
        return res.formVaildCheck;
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserDetail(prev => ({ ...prev, [name]: value }));

        // Clear error when the user types
        if (value) {
            setErrorsInfo(prev => ({ ...prev, [name]: '' }));
        }
    };

    const loginUserSubmit = async (e) => {
        e.preventDefault();
        try {
            if (await checkFormIsValid()) {
                dispatch(callCommonAction({ loading: true }));
                const res = await sendRequest(`/login`, "POST", userDetail);
                dispatch(callCommonAction({ loading: false }));
                handleApiResponse(res)
                if (res?.data?.type === 'success') {
                    localStorage.setItem("email", userDetail.email);
                    localStorage.setItem('user', JSON.stringify(res.data.user));
                    localStorage.setItem('isLoggedIn', true);
					localStorage.setItem("token", res.data.token);

					dispatch(callCommonAction({ isLoggedIn: true, user: res.data.user, token: res.data.access_token }));

                    navigate(appRoutes.listProposalRoute);
                }
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
            dispatch(callCommonAction({ loading: false }));
        }
    };

    return (
       
            <div className="d-flex justify-content-center w-100 login-main">
                <div className="col-md-12 col-lg-12">
                    <div className="d-flex flex-md-row flex-column shadow rounded overflow-hidden vh-100 align-items-center">
                       
                        
                        <div className="p-4 p-md-6 w-100 px-5">
                            <div className='form-box m-auto'>
                            <div className="d-flex justify-content-center mb-4">
                                <h3 className="mb-0 text-uppercase">Sign In</h3>
                            </div>
                            <form onSubmit={loginUserSubmit}>
                                <div className="mb-3">

                                    <div className='relative'>
                                    <i class="fa-solid fa-envelope input-i"></i>
                                    <input type="text" placeholder='Enter Email Address' name="email" id="email" className="form-control" value={userDetail.email}
                                        onChange={handleChange} onBlur={() => checkFormIsValid("email")}/></div>
                                    {errorsInfo.email && (<p className="text-danger">{errorsInfo.email}</p>)}
                                </div>

                                <div className="mb-3">
                                <div className='relative'>
                                <i class="fa-solid fa-unlock-keyhole input-i"></i>
                                    <input type="password" name="password" placeholder='Enter Password' id="password" className="form-control" value={userDetail.password} onChange={handleChange} onBlur={() => checkFormIsValid("password")} />
                                    </div>
                                    {errorsInfo.password && (<p className="text-danger">{errorsInfo.password}</p>)}
                                </div>

                                <div className="d-flex justify-content-end align-items-center mb-3">
                                    <a href="#" className="text-decoration-none forgot-text" onClick={(e) => {
                                        e.preventDefault();
                                        const navigateTo = params?.id ? `${appRoutes.forgotPasswordPageRoute}/${params.id}` : appRoutes.forgotPasswordPageRoute;
                                        navigate(navigateTo);
                                    }}>
                                       Forgot Password? <span className='yellow'></span>
                                    </a>
                                </div>

                                <div className="text-center mb-4">
                                    <button type="submit" disabled={loading} className="w-100 btn-lg btn-primary shadow btn btn-primary btn-yellow">
                                        {
                                            loading
                                                ? <span className="indicator-progress" style={{ display: 'block' }}>
                                                    Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                                : <span className="indicator-label text-uppercase">Sign In</span>
                                        }
                                    </button>
                                </div>
                              
                              
                            </form>
                        </div>
                        </div>

                        <div className="w-100 p-15 vh-100 form-right d-flex align-items-center justify-content-center">
                       
                       <div className='login-right-inner text-center'> 
                        <span className='d-block mb-4'><img src="./assets/images/image.png" alt="No Data Found"/></span>
                        <img src="./assets/images/login-img.png" alt="No Data Found"/>
                        <h3 className='mt-4 text-white'>Document Selection and Aggregation Tool</h3>
                        <p className='fs-6 text-white mt-3'>A <b>PDF builder</b> tool that allows users to create <b>customized</b> PDFs by selecting pages from multiple <b>PDF</b> files and adding new content through an integrated form interface.</p>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
       
    );
};

export default Login;
